module.exports = __webpack_public_path__ + "static/prepped-mobile-2-d8af6442af91ec4c40809e55aa06d948.jpg";